import Background from "./components/background";
import Entries from "./components/entries";
import Takeover from "./components/takeover";
import PixelMap from "./components/pixlemap";
import {MotionConfig} from "framer-motion";
import * as AppEventsService from '../../../../services/app-events.service';
import TemplateEventsEnum from "../../../../enums/TemplateEvents.enum";
import {useFastLane} from "./store";
import {DisplayType, FastLaneInstance} from "./types";
import {useEffect} from "react";
import {DEFAULT_EASE} from "../../../rise/constants/transition";
import EditorLayer from "./components/editor-layer";
import {FastLaneContextProvider} from "./store/fast-lane-context";
import LiveEditorController from "./components/live-editor-controller";
import './fonts.scss';
import SequenceAndTakeoverController from "./components/sequence-and-takeover-controller";
import useTickerTakeover from "../../../../services/takeover-service/takeover-ticker.hooks";
import ColorRush from './components/color-rush';
import { shouldPlayTakeover } from '../../../rise/animations/fastlane-kids-takeover/shared';
import { scheduleRecurringEvent } from './helpers';

interface FastLaneProps {
    instance: FastLaneInstance;
    display: DisplayType;
    preventInitializing?: boolean;
}

export default function FastLane({instance, display, preventInitializing}: FastLaneProps) {
    const initializeInstance = useFastLane(f => f.initializeInstance);
    const playHeadline = useFastLane(f => f.playContentRotation);
    const resetPlayingIndex = useFastLane(f => f.resetPlayingIndex);
    const stopSequence = useFastLane(f => f.stopSequence);

    useEffect(() => {
        if (preventInitializing) {
            return;
        }
        AppEventsService.sendEvent(TemplateEventsEnum.Init);
        initializeInstance(instance, display);
        AppEventsService.sendEvent(TemplateEventsEnum.InitEnd);
        playHeadline();
    }, []);

    const pixelMap = instance.pixelMap.ticker;

    const {
        component: takeoverComponent,
        primaryColor,
    } = useTickerTakeover({
        canvas_width: pixelMap.contentWidth,
        canvas_height: pixelMap.wrapperHeight,
        width: pixelMap.wrapperWidth,
        height: pixelMap.contentHeight,
    });

    useEffect(() => {
        console.log('[color-rush] setting up recurring event');
        scheduleRecurringEvent(60, () => {
            stopSequence();
            resetPlayingIndex();
            playHeadline();
            console.log('[color-rush] triggering playing headline');
        });
    }, []);
    
    return (
        <FastLaneContextProvider displayType={display} instance={instance}>

            <LiveEditorController/>
            <SequenceAndTakeoverController instance={instance}/>

            <MotionConfig transition={DEFAULT_EASE}>
                <div
                    style={{
                        // @ts-ignore
                        '--primary-color': display === 'ticker' ? primaryColor : undefined,
                    }}
                >
                    <PixelMap>
                        {(lane) => (
                            <div id={`fast-lane-container-${lane.laneIndex}`} className="fast-lane-container">
                                <Background
                                    laneIndex={lane.laneIndex}
                                    totalLanes={lane.totalLanes}
                                />
                                <ColorRush />
                                <Entries/>
                                <Takeover/>
                                <EditorLayer/>
                            </div>
                        )}
                    </PixelMap>

                    {display === 'ticker' && takeoverComponent ? takeoverComponent : null}
                </div>
            </MotionConfig>
        </FastLaneContextProvider>
    );
}
